<button-badge icon="bi-bell" [badge]="unreadCount()" [dropdown]="true" [width]="25" #root class="root-container">
  <div class="dropdown-header" slot="header">
    <h3>Notifications </h3>
    <span id="notif-count" [class]="!unreadCount() ? 'd-none' : ''">{{ unreadCount() }}</span>
  </div>
  <div class="dropdown-body scrollbars" slot="body">
    @for (link of items(); track $index; let last = $last) {
      <notification-link 
      [linkPrefix]="linkPrefix" 
      [notification]="link" 
      [role]="auth.getCurrentRole()" />

      @if(last && notificationApi.count() > 10) {
      <div (click)="notificationApi.loadMore()" class="view-more">view more</div>
      }
    }
    @empty {
      <div id="empty">
        You have no notifications
      </div>
    }
  </div>
</button-badge>
